const translations = {
  ko: {
    home: '홈',
    receivedGifts: '선물받은 기프트',
    sentGifts: '선물한 기프트',
    giftStatus: '기프트 관리',
    giftVerification: '기프트 검증',
    sendGift: '선물하기',
    validityPeriodDate: '유효기간 : ',
    validityPeriod: months => `유효기간 : 구매일로부터 ${months}개월`,
    paymentCondition: hours =>
      `지급조건 : 기프트 QR 코드 스캔 후 ${hours}시간 후 구매대금 상점으로 자동송금(환불불가)`,
    giftSerial: '기프트 시리얼 :',
    state: '상태 :',
    sender: '보낸사람 :',
    senderPhone: '보낸사람 전화번호 :',
    senderEmail: '보낸사람 이메일 :',
    giftMessage: '선물 문구',
    unused: '사용전',
    unavailable: '사용불가',
    all: '전체',
    sendGiftAction: '선물 보내기',
    copyGiftLink: '선물받기 링크 복사해서 알아서 보낼게요.',
    sendGiftLinkInstruction: 'SMS나 이메일로 선물받기 링크 보내주세요.',
    makePayment: '결제하기',
    giftSuccess: '기프트 선물하기 성공!',
    checkSentGift: '선물한 기프트에서 확인하실 수 있습니다.',
    recipientPhone: '받는 분 전화번호',
    recipientEmail: '받는 분 이메일',
    giftNote: '선물 문구',
    within50Chars: '(50자 이내)',
    giftReceiveLink: '선물받기 링크',
    copyLink: '링크 복사하기',
    giftQr: '기프트 QR 코드',
    money: '원',
    orderForm: '주문서',
    afterReceivingGift: '선물 받은 후',
    month: '달',
    day: '일',
    noValidityInfo: '유효기간 정보 없음',
    giftDetails: '선물내역',
    giftState: '미사용',
    receiveGiftInstructions: '기프트 선물을 받으시려면',
    clickLink: '아래 링크를 클릭',
    validity: '유효기간 :',
    giftCondition:
      '지급조건 : 기프트 QR 코드 스캔 후 1시간 후 구매대금 상점으로 자동송금(환불불가)',
    giftSerialNumber: '기프트 시리얼 :',
    salesState: '판매상태 :',
    senderPhoneNumber: '보낸사람 전화번호',
    giftMessageText: '선물 문구',
    giftReceiveLinkText: '선물받기 링크',
    giftReceiveSuccess: '선물받기 성공',
    giftReceiveFailure: '선물받기 실패',
    giftSendSuccess: '기프트 선물하기 성공!',
    giftSendFailure: '기프트 선물하기 실패!',
    giftVerificationSuccess: '기프트 검증 성공!',
    giftVerificationFailure: '기프트 검증 실패!',
    couponVerificationSuccess: '쿠폰 검증 성공!',
    couponVerificationFailure: '쿠폰 검증 실패!',
    couponDiscountAmountLabel: '할인 금액',
    couponVerifyingInProgress: '쿠폰 검증 중...',
    couponVerifyBackToScan: '스캔으로 돌아가기',
    giftClaimSuccess: '기프트 선물받기 성공!',
    giftClaimFailure: '기프트 선물받기 실패!',
    checkReceivedGift:
      '받은 기프트는 선물받은 기프트에서 확인하실 수 있습니다.',
    reason: '사유 :',
    paymentError: '결제 오류',
    expiredValidity: '유효기간 경과',
    verificationReason: '검증 실패 사유 :',
    claimReason: '받기 사유 :',
    totalIssued: '총발행수량',
    totalSold: '누적판매수량',
    totalSalesAmount: '누적판매금액',
    registrationDate: '등록일',
    giftId: '기프트 아이디',
    verificationSuccess: '검증 성공',
    verificationFailed: '검증 실패',
    revertToUnused: '사용취소',
    revertToUnusedConfirm:
      '고객이 실물을 받지 못한 컴플레인인 경우에만 사용하세요. 기프트 상태를 사용전으로 되돌리시겠습니까?',
    revertToUnusedSuccess: '기프트 상태가 사용전으로 변경되었습니다.',
    revertToUnusedErrorInvalid:
      '존재하지 않거나 잘못된 기프트 번호입니다. 페이지를 새로고침 후 다시 시도해 주세요.',
    adminLogin: '관리자 로그인',
    loginUsername: '아이디',
    loginPassword: '비밀번호',
    saveId: '아이디저장',
    autoLogin: '자동로그인',
    login: '로그인',
    loginEnterBoth: '아이디와 비밀번호를 모두 입력해주세요.',
    loginFailed: '로그인 실패',
    wrongPassword: '비밀번호가 일치하지 않습니다.',
    userNotFound: '존재하지 않는 아이디입니다.',
    storeDeactivated: '영업중지된 상점입니다. 상점지원센터에 문의해주세요(070-4010-8203).',
    loginFailedGeneric: '로그인에 실패했습니다.',
    confirm: '확인',
    storeMismatch: '상점 불일치',
    storeMismatchMessage:
      '다른 상점 관리자 아이디({id}) 로<br/>로그인 하셨습니다',
    goToStore: '해당 상점으로 이동',
    adminLogout: '관리자 로그아웃',
    userLogout: '사용자 로그아웃',
    footerAddress:
      '인천 미추홀구 석정로 229, 811호 (도화동,인천블록체인허브센터)',
    phone: '010-1111-2222',
    email: 'bombom@gmail.com',
    giftHome: '기프트홈',
    poweredBy: 'Copyright by (주)오스리움. All Rights Reserved',
    // 상태값 번역
    stateDesc: {
      미사용: '미사용',
      사용완료: '사용완료',
      기사용오류: '기사용오류',
      유효기간오류: '유효기간오류',
      판매등록: '판매예정',
      판매예정: '판매예정',
      판매중지: '판매중지',
      판매시작: '판매시작',
      판매종료: '판매종료',
      판매취소: '판매취소',
    },
    saleStartDate: '판매시작일',
    saleEndDate: '판매종료일',
    kakaoGiftLink: '카카오톡 공유하기로 링크 보내주세요',
    kakaoShare: '카카오톡 공유하기',
    bizNumLabel: '사업자등록번호',
    representativeLabel: '대표자',
    addressLabel: '주소',
    storeNameLabel: '상호',
    operationHoursLabel: '고객센터 운영시간',
    serviceTerms: '서비스이용약관',
    privacyPolicy: '개인정보처리방침',
    phoneLabel: '전화번호',
    ownerRefundRequest: '상점주 환불 요청',
    ownerRefundConfirm:
      '실증 테스트 건에 대해 100% 환불(결제취소)을 요청합니다. 오퍼레이터 승인 후 처리됩니다.',
    ownerRefundSuccess: '환불 요청이 접수되었습니다.',
    ownerRefundFailed: '환불 요청에 실패했습니다.',
    ownerRefundPending: '환불 요청됨 (처리 대기)',
    ownerRefundFailedStatus: '환불 실패',
    ownerRefundCompleted: '환불 완료',
    ownerRefundMissingPayment: '결제 정보가 없어 환불 요청할 수 없습니다.',
    myInfoTitle: '상점관리자 정보',
    myInfoName: '이름',
    myInfoMobile: '휴대폰',
    myInfoLoading: '불러오는 중...',
    // 상점홈 공지 팝업 (components/common/NoticePopup.js)
    processing: '처리 중...',
    noticeRequiredLabel: '필수 공지',
    noticeAgree: '동의',
    noticeConfirm: '확인',
    noticeClose: '닫기',
    noticeConsentFailed:
      '동의 처리에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    noticeScrollToEnd: '내용을 끝까지 확인하셔야 동의할 수 있습니다.',
    noticeHideToday: '오늘 그만보기',
    // 상점관리자 공지 게시판 (pages/admin/NoticeBoard.js)
    noticeBoardTitle: '공지사항',
    noticeBoardLoading: '불러오는 중...',
    noticeBoardError: '공지를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.',
    noticeBoardEmpty: '등록된 공지가 없습니다.',
    noticeBoardMore: '더 보기',
    noticeBoardMoreLoading: '불러오는 중...',
    noticeBoardMoreError: '더 불러오지 못했습니다. 다시 시도해 주세요.',
    noticeBoardNotFound: '존재하지 않는 공지입니다.',
    noticeBoardToList: '목록으로',
  },
  en: {
    home: 'Home',
    receivedGifts: 'Received gifts',
    sentGifts: 'Sent gifts',
    validityPeriodDate: 'Validity period: ',
    giftStatus: 'Gift management',
    giftVerification: 'Gift verification',
    sendGift: 'Send gift',
    validityPeriod: months =>
      `Validity period: ${months} months after purchase`,
    paymentCondition: hours =>
      `Payment condition: The purchase amount will be automatically remitted to the store ${hours} hours after the gift QR code is scanned (Non-refundable)`,
    giftSerial: 'Gift serial :',
    state: 'State :',
    sender: 'Sender :',
    senderPhone: 'Sender phone :',
    senderEmail: 'Sender email :',
    giftMessage: 'Gift message',
    unused: 'Unused',
    unavailable: 'Unavailable',
    all: 'All',
    sendGiftAction: 'Send gift',
    copyGiftLink: 'I will copy and send the gift link myself.',
    sendGiftLinkInstruction: 'Please send the gift link via SMS or email.',
    makePayment: 'Make payment',
    giftSuccess: 'Gift sent successfully via Cafe Bombom!',
    checkSentGift: 'You can check it in the sent gifts.',
    recipientPhone: 'Recipient phone',
    recipientEmail: 'Recipient email',
    giftNote: 'Gift note',
    within50Chars: '(within 50 characters)',
    giftReceiveLink: 'Gift receive link',
    copyLink: 'Copy link',
    giftQr: 'Gift QR code',
    money: 'KRW',
    orderForm: 'Order form',
    afterReceivingGift: 'After receiving the gift',
    month: 'Months',
    day: 'Days',
    noValidityInfo: 'No validity information available',
    giftDetails: 'Gift details',
    giftState: 'Unused',
    receiveGiftInstructions: 'To receive the gift',
    clickLink: 'Please click the link below.',
    validity: 'Validity period:',
    giftCondition:
      'Payment condition: The purchase amount will be automatically remitted to the store 1 hour after scanning the gift QR code (Non-refundable)',
    giftSerialNumber: 'Gift serial :',
    salesState: 'Sales status :',
    senderPhoneNumber: 'Sender phone',
    giftMessageText: 'Gift message',
    giftReceiveLinkText: 'Gift receive link',
    giftReceiveSuccess: 'Gift received successfully',
    giftReceiveFailure: 'Gift receiving failed',
    giftSendSuccess: 'Gift sent successfully!',
    giftSendFailure: 'Gift sending failed!',
    giftVerificationSuccess: 'Gift verification successful!',
    giftVerificationFailure: 'Gift verification failed!',
    couponVerificationSuccess: 'Coupon verified!',
    couponVerificationFailure: 'Coupon verification failed!',
    couponDiscountAmountLabel: 'Discount',
    couponVerifyingInProgress: 'Verifying coupon...',
    couponVerifyBackToScan: 'Back to scanner',
    giftClaimSuccess: 'Gift received successfully!',
    giftClaimFailure: 'Gift receiving failed!',
    checkReceivedGift: 'You can check the received gift in the received gifts.',
    reason: 'Reason:',
    paymentError: 'Payment error',
    expiredValidity: 'Expired validity',
    verificationReason: 'Verification failure reason :',
    claimReason: 'Claim reason :',
    totalIssued: 'Total issued',
    totalSold: 'Total sold',
    totalSalesAmount: 'Total sales amount',
    registrationDate: 'Registration date',
    giftId: 'Gift id',
    verificationSuccess: 'Verification success',
    verificationFailed: 'Verification failed',
    revertToUnused: 'Cancel use',
    revertToUnusedConfirm:
      'Use only when a customer complains they did not receive the physical item. Revert gift status to unused?',
    revertToUnusedSuccess: 'Gift status has been reverted to unused.',
    revertToUnusedErrorInvalid:
      'Invalid or non-existent gift number. Please refresh the page and try again.',
    adminLogin: 'Admin login',
    loginUsername: 'Username',
    loginPassword: 'Password',
    saveId: 'Save ID',
    autoLogin: 'Auto login',
    login: 'Login',
    loginEnterBoth: 'Please enter both username and password.',
    loginFailed: 'Login failed',
    wrongPassword: 'Incorrect password.',
    userNotFound: 'User not found.',
    storeDeactivated: 'This store has been deactivated. Please contact support.',
    loginFailedGeneric: 'Login failed.',
    confirm: 'Confirm',
    storeMismatch: 'Store mismatch',
    storeMismatchMessage:
      'You have logged in with a different store admin account ({id})',
    goToStore: 'Go to store',
    adminLogout: 'Admin logout',
    userLogout: 'User logout',
    footerAddress:
      '229, Seokjeong-ro, Michuhol-gu, Incheon, 811 (Dohwa-dong, Incheon Blockchain Hub Center)',
    phone: '010-1111-2222',
    email: 'bombom@gmail.com',
    giftHome: 'Gift home',
    poweredBy: 'Copyright by Authrium Co., Ltd. All Rights Reserved.',
    // 상태값 번역
    stateDesc: {
      미사용: 'Unused',
      사용완료: 'Used',
      기사용오류: 'Use error',
      유효기간오류: 'Expired',
      판매등록: 'Planned sale',
      판매예정: 'Planned sale',
      판매중지: 'Sales discontinued',
      판매시작: 'Sale started',
      판매종료: 'Sale ended',
      판매취소: 'Sale cancelled',
    },
    saleStartDate: 'Sale start Date',
    saleEndDate: 'Sale end Date',
    kakaoGiftLink: 'Send the link via KakaoTalk Share ',
    kakaoShare: 'KakaoTalk Share',
    bizNumLabel: 'Business registration no.',
    representativeLabel: 'Representative',
    addressLabel: 'Address',
    storeNameLabel: 'Business name',
    operationHoursLabel: 'Customer service hours',
    serviceTerms: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    phoneLabel: 'Phone',
    ownerRefundRequest: 'Request test refund',
    ownerRefundConfirm:
      'Request a 100% refund (payment cancel) for this pilot test purchase. An operator will process it.',
    ownerRefundSuccess: 'Refund request submitted.',
    ownerRefundFailed: 'Refund request failed.',
    ownerRefundPending: 'Refund requested (pending)',
    ownerRefundFailedStatus: 'Refund failed',
    ownerRefundCompleted: 'Refund completed',
    ownerRefundMissingPayment:
      'Payment info is missing; cannot request refund.',
    myInfoTitle: 'Store Admin Info',
    myInfoName: 'Name',
    myInfoMobile: 'Mobile',
    myInfoLoading: 'Loading...',
    // 상점홈 공지 팝업 (components/common/NoticePopup.js)
    processing: 'Processing...',
    noticeRequiredLabel: 'Required notice',
    noticeAgree: 'Agree',
    noticeConfirm: 'Confirm',
    noticeClose: 'Close',
    noticeConsentFailed: 'Failed to record your consent. Please try again.',
    noticeScrollToEnd: 'Please read to the end before agreeing.',
    noticeHideToday: "Don't show today",
    // 상점관리자 공지 게시판 (pages/admin/NoticeBoard.js)
    noticeBoardTitle: 'Notices',
    noticeBoardLoading: 'Loading...',
    noticeBoardError: 'Failed to load notices. Please try again later.',
    noticeBoardEmpty: 'No notices yet.',
    noticeBoardMore: 'Load more',
    noticeBoardMoreLoading: 'Loading...',
    noticeBoardMoreError: 'Failed to load more. Please try again.',
    noticeBoardNotFound: 'This notice does not exist.',
    noticeBoardToList: 'Back to list',
  },
};

export default translations;
